import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ios-pwa-checker"
export default class extends Controller {
  connect() {
    fetch('/ios_pwa_checker', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: new URLSearchParams({ ios_pwa: window.navigator.standalone || window.matchMedia('(display-mode: standalone)').matches })
    })
  }
}
